import { AVATAR_COLORS } from '../constants/avatarColors'

export const getAvatarColor = (index: number): string => AVATAR_COLORS[index % AVATAR_COLORS.length]
